module.exports = __webpack_public_path__ + "static/media/13.1c3a5c86.jpg";